// Paths that belong to the web app (web.chesswiz.net), not this landing site.
// Emails and shares link to chesswiz.net/<path> so the mobile app can claim them
// as universal/app links; on a desktop browser they must be forwarded instead.
export const WEB_APP_PATH_PATTERN =
  '^/(practice|games|moves|share|analysis|analytics|scout|simulator|try|payment|subscription)(/|$)';

export const WEB_APP_ORIGIN = 'https://web.chesswiz.net';

type LocationLike = Pick<Location, 'pathname' | 'search' | 'hash'>;

// Target on the web app for a landing-site URL, or null when the path is ours.
// Also recovers the `/?/practice/...` form the GitHub Pages 404 fallback used to
// produce for these paths, so old links still land in the right place.
export function resolveWebAppRedirect(l: LocationLike): string | null {
  let { pathname, search } = l;
  if (search.startsWith('?/')) {
    const [path, ...query] = search.slice(1).split('&');
    pathname = path.replace(/~and~/g, '&');
    search = query.length ? '?' + query.join('&').replace(/~and~/g, '&') : '';
  }
  if (!new RegExp(WEB_APP_PATH_PATTERN, 'i').test(pathname)) return null;
  return WEB_APP_ORIGIN + pathname + search + l.hash;
}

// Mirrors the cookie the web client sets on .chesswiz.net while a user is signed in.
export const SIGNED_IN_COOKIE = 'cw_signed_in';

// Signed-in visitors landing on the home page go straight to the web app. The cookie
// value is its own expiry (epoch ms), so a stale or malformed marker never redirects.
export function resolveSignedInRedirect(l: LocationLike, cookie: string, now = Date.now()): string | null {
  if (l.pathname !== '/' || l.search.startsWith('?/')) return null;
  const entry = cookie.split(';').map(c => c.trim()).find(c => c.startsWith(`${SIGNED_IN_COOKIE}=`));
  const expiresAt = Number(entry?.slice(SIGNED_IN_COOKIE.length + 1));
  return Number.isFinite(expiresAt) && expiresAt > now ? WEB_APP_ORIGIN + l.search + l.hash : null;
}
